import React from "react";
import "./css/NoRecords.scss";
// Images

import ImgNoRecords from "../assets/images/img_no_records.png";

const NoRecords = ({ isShow, customMessage }) => {
  if (customMessage) {
    return (
      <div
        id='noRecordsContainer'
        style={{ display: isShow ? "flex" : "none" }}
      >
        <img src={ImgNoRecords} alt='no-records-found' />
        {customMessage}
      </div>
    );
  } else {
    return (
      <div
        id='noRecordsContainer'
        style={{ display: isShow ? "flex" : "none" }}
      >
        <img src={ImgNoRecords} alt='no-records-found' />
        No records found! Please make another request.
      </div>
    );
  }
};

export default NoRecords;
